<template>
  <transition name="fade">
    <section v-if="isCopyrightShow" class="copyright-section" ref="wrap">
      <v-btn
        class="close-btn"
        :linear="true"
        color="#ffffff"
        @btnClick="on_close_btn_click"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <div v-html="copyrightContent"></div>
    </section>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "copyright",
  computed: {
    ...mapState("global", ["isCopyrightShow"]),
    ...mapGetters("global", ["copyrightContent"]),
  },

  data() {
    this.isLightMode = false;
    return {};
  },
  methods: {
    ...mapMutations("global", ["updateIsCopyrightShow"]),
    on_close_btn_click() {
      this.updateIsCopyrightShow(false);
    },
  },
};
</script>

<style lang="scss">
.copyright-section {
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #152f65;
  display: flex;
  justify-content: center;
  align-items: center;
  p,
  h4 {
    font-size: 22px;
    line-height: 40px;
    color: #fff;
    text-indent: 0;
    text-align: center;
  }
  h4 {
    font-size: 24px;
    margin-bottom: 48px;
  }

  .close-btn {
    position: fixed;
    top: 30px;
    right: 54px;
    z-index: 99999;
    &:hover {
      i {
        color: $color-navigation !important;
      }
    }
    .borderCircle {
      border-color: rgba(#fff, 0.8);
    }
    i {
      color: #fff;
    }
  }
}
</style>
